import CryptoJS from 'crypto-js'
import { _config } from '../config'

export function encrypt(data) {
	return CryptoJS.AES.encrypt(data, _config.encryptPasswordKey).toString()
}
